export enum SearchContextApiEnum {
    headline = 'HEADLINE',
    lead = 'LEAD',
    body = 'BODY',
    image = 'IMAGE'
}
